module.exports = __webpack_public_path__ + "img/38-Amaranth Oak VLF.jpg";